import { createStyles, Theme } from '@material-ui/core/styles';
import colors from '../../utils/colors';

export default createStyles((theme: Theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 15,
    boxShadow: '0 4px 16px 0 rgba(0,0,0,0.08)',
    padding: 16,
  },

  //Header
  cardHeader: {
    position: 'relative',
    width: '100%',
    margin: '10px 0',
    minHeight: '40px',
    '&  .MuiCircularProgress-colorPrimary': {
      color: `${colors.darkGold} !important`,
      zIndex: 2,
    },
    '&  .MuiCircularProgress-colorSecondary': {
      color: `${colors.secondaryWhite} !important`,
    },
  },
  cardTitle: {
    color: colors.dark,
    margin: '0!important',
    fontSize: '18px',
    paddingRight: '64px',
  },
  percentageIndicator: {
    position: 'absolute',
    top: '-10px',
    right: 0,
  },
  highlighedNumber: {
    color: colors.white,
    width: '40px',
    height: '40px',
    fontSize: '16px',
    lineHeight: '16px',
    backgroundColor: colors.red,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  //Container styles
  containerDark: {
    backgroundColor: colors.dark,
    color: colors.white,

    '& $cardTitle': {
      color: colors.white,
    },

    '& $percentageIndicator': {
      color: colors.white,
    },
  },
  containerWhite: {
    backgroundColor: colors.white,
  },
  containerGold: {
    backgroundColor: colors.gold,
  },

  //Single stat

  singleStat: {
    width: '100%',
    padding: 10,
    margin: '5px 0',
  },

  //Heading before items
  headingBefore: {
    textAlign: 'left',
    fontSize: '12px',
    width: '100%',
    margin: '10px 0',
  },

  //Layouts

  //Regular
  itemTitle: {
    fontSize: '14px',
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
  itemCountRight: {
    textAlign: 'right',
    fontSize: '18px',
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
      cursor: 'pointer',
      margin: '-10px',
      padding: '10px 10px 10px 40px',
    },
  },

  // Title and count
  itemTitleSmall: {
    fontSize: '12px',
    marginBottom: 0,
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
  itemCountLarge: {
    fontSize: '24px',
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },

  //Variant styles
  noBgWhite: {
    backgroundColor: 'transparent',
    color: colors.white,
    boxShadow: 'none!important',
    margin: 0,
    //Loader color
    '&  .MuiCircularProgress-colorPrimary': {
      color: `${colors.white} !important`,
    },
  },
  noBgBlack: {
    backgroundColor: 'transparent',
    color: colors.black,
    boxShadow: 'none!important',
    margin: 0,
  },
  whitePaper: {
    color: colors.dark,
    //Loader color
    '&  .MuiCircularProgress-colorPrimary': {
      color: `${colors.dark} !important`,
    },
  },
  goldPaper: {
    backgroundColor: colors.lightGold,
    color: colors.dark,
  },

  //Dwell Badge

  itemDwellBadge: {
    fontSize: '12px',
    background: colors.gold,
    color: colors.white,
    padding: '0px 10px',
    borderRadius: '10px',
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },

  //SwitchBox
  switchBox: {
    width: '100%',
    textAlign: 'right',
  },

  switchTrack: {
    backgroundColor: colors.gold,
    opacity: 1,
  },

  //Filter tooltip
  filterTooltip: {
    '& p': {
      fontSize: '12px',
    },
    '& ul': {
      fontSize: '12px',
      padding: '0 0 0 20px',
    },
  },
  filterIcon: {
    fontSize: '18px',
    background: colors.gold,
    color: colors.white,
    padding: '2px',
    borderRadius: '50%',
    margin: '0 5px -2px 0',
  },
}));
